import { useNavigate } from "react-router-dom";
import { Church, ArrowLeft, Bell, Users } from "lucide-react";

export default function ChurchFamilyAuthPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(135deg, #073B4C 0%, #118AB2 50%, #06D6A0 100%)" }}>
      <div className="min-h-screen flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {/* Top bar with back */}
          <div className="flex items-center justify-between mb-6">
            <button onClick={() => navigate("/")}
              className="flex items-center gap-1.5 text-white/80 hover:text-white font-bold text-sm">
              <ArrowLeft size={16} /> Back to Home
            </button>
          </div>

          {/* Header */}
          <div className="text-center mb-8">
            <div className="bg-white/20 rounded-full p-5 w-24 h-24 flex items-center justify-center mx-auto mb-4">
              <Users size={48} color="white" strokeWidth={2} />
            </div>
            <h1 className="text-3xl font-black text-white mb-2" style={{ fontFamily: "Fredoka, sans-serif" }}>
              Church Family
            </h1>
            <p className="text-white/80 font-medium">
              Join your church's Bible Buds community
            </p>
          </div>

          {/* Coming Soon Card */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 text-center">
            <div className="bg-purple-100 rounded-full p-4 w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <Bell size={40} color="#9B5DE5" />
            </div>
            <h2 className="text-2xl font-black text-[#073B4C] mb-2" style={{ fontFamily: "Fredoka, sans-serif" }}>
              Coming Soon!
            </h2>
            <p className="text-gray-600 mb-6">
              Church family registration with invite codes is coming soon. In the meantime, start your own family account!
            </p>
            
            <div className="bg-purple-50 rounded-2xl p-4 mb-6">
              <p className="text-sm text-[#9B5DE5] font-medium">
                Want to be notified when we launch?
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Email us at <a href="mailto:support@biblebuds.space" className="text-[#9B5DE5] font-bold hover:underline">support@biblebuds.space</a>
              </p>
            </div>

            <button
              onClick={() => navigate("/auth")}
              className="w-full bg-gradient-to-r from-[#9B5DE5] to-[#EF476F] text-white font-black py-3 rounded-xl hover:opacity-90 transition-all"
              style={{ fontFamily: "Fredoka, sans-serif" }}
            >
              Start Family Account Instead
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
